import { useEffect } from 'react';

import { ErrorMessage } from '@providers/ErrorContextProvider';

/**
 * Render warning message in case of emergency
 */
const useEmergencyState = (
  isFallbackPsp: boolean,
  isMyAccount: boolean,
  t: (key: string) => string,
  setError: (errorMessage?: ErrorMessage) => void,
) => {
  useEffect(() => {
    if (isFallbackPsp) {
      const errorMessage = isMyAccount
        ? t('myaccount.credit.card.payment.psp.failure.message')
        : t('checkout.credit.card.payment.psp.failure.message');
      setError({
        message: errorMessage,
        retryable: true,
        variant: 'info',
      });
    } else {
      setError(undefined);
    }
  }, [t, isFallbackPsp, setError, isMyAccount]);
};

export default useEmergencyState;
